<template>
  <article class="flex w-full flex-col items-center laptop:flex-row">
    <div
      class="flex w-full max-w-[148px] items-center justify-center tablet:max-w-[340px]"
      :class="{
        'laptop:order-2': index % 2 != 0,
        'laptop:ml-[40px]': index % 2 != 0,
        'laptop:ml-[98px]': index % 2 != 0,
      }"
    >
      <img
        class="h-auto w-full max-w-[148px] object-contain tablet:max-w-[340px]"
        :src="props.news?.attributes?.Image?.data?.attributes?.url"
        :alt="'alt'"
        loading="lazy"
        width="340"
        height="340"
      />
    </div>
    <div
      class="mt-4 flex w-full flex-col tablet:mt-0 laptop:min-w-[400px]"
      :class="{
        'order-1': index % 2 == 0,
        'laptop:ml-[40px]': index % 2 == 0,
        'laptop:ml-[98px]': index % 2 == 0,
      }"
    >
      <time class="date" :date="props.news?.attributes?.Date">{{ dateFormatted }}</time>
      <h3 class="mt-2 max-w-[240px] laptop:mt-4">{{ props.news?.attributes?.Title }}</h3>
      <p class="mt-4 laptop:mt-10">{{ props.news?.attributes?.IntroText }}</p>
      <NextBtn
        class="mt-4 ml-auto laptop:mt-10"
        :text="$t('Read More')"
        :to="localePath({ name: 'news-newsId', params: { newsId: `${props.news?.attributes?.slug}` } })"
      />
    </div>
  </article>
</template>
<script setup lang="ts">
import { BlogPostAttributesFragment } from "#gql";
import { useDateFormatted } from "~~/composables/dateFormatted";

const props = defineProps<{
  news: BlogPostAttributesFragment;
  index: number;
}>();

const { dateFormatted } = useDateFormatted(props.news?.attributes?.Date || props.news?.attributes?.createdAt);

const localePath = useLocalePath();
</script>
<style lang="scss" scoped></style>
